const interfacePhrases = {
    rate_limited: 'Обмеження частоти',
    limit_exceeded: 'Перевищення ліміту',
    used: 'Використання',
    identifier: 'Ідентифікатор',
    verification: 'Перевірка',
    messages: 'Повідомлення',
    data: 'Дані',
    custom: 'Користувацький',
    management_api: 'API керування {{product}}',
    management_api_role_description: 'Ця вбудована роль надає доступ до API керування.',
    client_credentials: 'Облікові дані клієнта',
    authentication_request: 'Запит автентифікації',
    callback: 'Зворотний виклик автентифікації',
    help_title: 'Центр допомоги iden',
    help_subtitle: 'Допомога без виходу з робочого простору',
    open_help: 'Відкрити повну сторінку допомоги',
    close_help: 'Закрити допомогу',
    about: 'Про продукт і відкрите ПЗ',
    open_navigation: 'Відкрити навігацію',
    close_navigation: 'Закрити навігацію',
    development_enabled: 'Функції розробки ввімкнено',
    beta: 'Бета',
    impersonation: 'Вхід від імені користувача',
    key: 'Ключ',
    value: 'Значення',
    error: 'Помилка',
    details: 'Технічні подробиці',
    callback_failed: 'Не вдалося завершити зворотний виклик входу.',
    back_sign_in: 'Повернутися до входу',
    powered_by: 'Працює на',
    avatar: 'Аватар',
    logo: 'Логотип',
    qr_code: 'QR-код',
    sample_title: 'Бажаєте побачити приклад?',
    sample_description: 'Перегляньте приклад застосунку, що використовує цей посібник.',
    sample_action: 'Переглянути приклад',
    further_readings: 'Додаткові матеріали',
    complete_guide: 'Повний посібник',
    custom_domains_notice: 'Після додавання <a>власних доменів</a> можна використовувати цю кінцеву точку: <code>{{endpoint}}</code>.',
    my_project: 'Мій проєкт',
    my_secret: 'Мій секрет',
    my_token: 'Мій токен',
    role_example: 'Читач',
    reset_retry: 'Скинути налаштування та повторити',
    open_dev_panel: 'Відкрити панель розробника',
    close_dev_panel: 'Закрити панель розробника',
    configuration: 'Налаштування',
    app_id: 'Ідентифікатор застосунку',
    extra_parameters: 'Додаткові параметри входу',
    prompt: 'Запит автентифікації',
    scope: 'Область доступу',
    resource: 'Ресурс',
    resources_space_delimited: 'Ресурси (через пробіл)',
    sign_out_to_apply: 'Вийдіть із системи, щоб застосувати зміни.',
    refresh_token_grant: 'Авторизація токеном оновлення',
    organization_id: 'Ідентифікатор організації',
    console_result: 'Результат доступний у консолі браузера.',
    request_token: 'Запросити токен',
    user_info: 'Інформація про користувача',
    get_id_token_claims: 'Отримати твердження токена ідентифікації',
    fetch_user_info: 'Завантажити інформацію про користувача',
    device_initializing: 'Ініціалізація авторизації пристрою…',
    device_success: 'Ви ввійшли до демонстраційного застосунку.',
    sign_in_information: 'Ваші дані входу:',
    email: 'Електронна пошта',
    username: 'Ім’я користувача',
    user_id: 'Ідентифікатор користувача',
    sign_out_demo: 'Вийти з демо',
    device_expired: 'Код пристрою прострочено',
    generic_error: 'Сталася помилка',
    device_expired_description: 'Термін дії коду пристрою минув. Спробуйте ще раз, щоб отримати новий код.',
    sign_in_title: 'Увійдіть до свого облікового запису',
    scan_instruction: 'Відскануйте QR-код або відкрийте цю адресу на іншому пристрої:',
    one_time_code: 'Введіть одноразовий код',
    token_info: 'Інформація про токен',
    get_access_token: 'Отримати токен доступу',
    context_unavailable: 'Не вдалося завантажити дані облікового запису.',
    not_initialized: 'Дані облікового запису не ініціалізовано.',
    not_set: 'Не задано',
    configured: 'Налаштовано',
    password: 'Пароль',
    phone: 'Номер телефону',
    search_help: 'Пошук у довідці',
    language: 'Мова',
    menu: 'Меню',
    compatibility_notice: 'Сумісність: успадковані назви SDK, пакетів, протоколів, компонентів і заголовків запитів Logto залишаються незмінними.',
    source: 'Джерело',
    upstream_repository: 'Початковий репозиторій',
    current_fork: 'Поточний репозиторій',
    license_notice: 'iden базується на Logto — відкритому програмному забезпеченні під ліцензією Mozilla Public License 2.0.',
    about_description: 'Інформація про продукт і авторство відкритого ПЗ.',
    page_not_found: 'Сторінку не знайдено',
    page_not_found_description: 'Ця сторінка недоступна. Поверніться до центру допомоги.',
    introduction: 'Вступ',
    quick_starts: 'Швидкий початок',
    integration: 'Інтеграція',
    end_user_flows: 'Сценарії кінцевих користувачів',
    authorization: 'Авторизація',
    user_management: 'Керування користувачами',
    security: 'Безпека',
    customization: 'Налаштування оформлення',
    connectors: 'Конектори',
    organizations: 'Організації',
    self_hosting: 'Власний хостинг',
    continue: 'Продовжити',
    loading: 'Завантаження…',
    save: 'Зберегти',
    saved: 'Збережено',
    try_again: 'Спробувати ще раз',
    client_id: 'Ідентифікатор клієнта',
    client_secret: 'Секрет клієнта',
    redirect_uri: 'URI перенаправлення',
    status: 'Статус',
    type: 'Тип',
    permissions: 'Дозволи',
    token_data: 'Дані токена',
    context_data: 'Дані контексту',
    jwt_extra_claims: 'Додаткові твердження токена',
    action_result: 'Результат дії',
    social_account_already_linked: 'Цей обліковий запис соцмережі вже пов’язано.',
};
export default Object.freeze(interfacePhrases);
